import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Paper, Skeleton, Typography } from '@esgian/esgianui';
import './kpi.css';

const KpiBox = ({ loading, icon, title, value, subtitle }) => {
  return (
    <Paper
      sx={{
        background: ({ palette }) => palette.background.paper,
        position: 'relative',
        display: 'flex',
        placeContent: 'center',
        placeItems: 'center',
        overflow: 'hidden',
        borderRadius: 1,
        borderLeft: ({ palette }) => `${loading ? 0 : 2}px solid ${palette.primary.main}`,
        flex: '1 1 auto',
        minWidth: '250px',
        // minHeight: '7em',
        '&::before': {
          content: "''",
          position: 'absolute',
          left: '-5%',
          top: '5%',
          width: '110%',
          height: '70%',
          backgroundImage: `linear-gradient(180deg, #00BDD6, #00D684)`,
          animation: loading ? 'rotBGimg 5s linear infinite' : 'none', // Conditionally apply animation
          transition: 'all 0.2s linear',
          display: loading ? 'block' : 'none' // Hide when loading is false
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          background: ({ palette }) => palette.background.paper,
          inset: '2px',
          borderRadius: '4px',
          zIndex: 0,
          display: loading ? 'block' : 'none' // Hide when loading is false
        }
      }}
      className="card">
      <Box sx={{ p: '12px 16px', zIndex: 1, width: '100%' }}>
        <Stack direction={'row'} spacing={1}>
          {React.cloneElement(icon, {
            color: 'inherit',
            sx: {
              mt: '5px !important',
              width: '0.75em',
              height: '0.75em',
              fill: ({ palette }) => palette.text.primary
            }
          })}
          <Stack>
            <Typography variant="subtitle1" fontWeight="bold">
              {title}
            </Typography>
            <Stack direction={'row'} spacing={1} sx={{ textWrap: 'nowrap' }}>
              {loading ? (
                <Skeleton height={'2em'} width={'4em'} />
              ) : (
                <Typography color={'primary'} variant="h5" fontWeight="bold">
                  {value}
                </Typography>
              )}
              {subtitle && (
                <Typography
                  sx={{
                    color: ({ palette }) => palette.text.secondary,
                    lineHeight: 1.5,
                    alignSelf: 'end',
                    pb: '2px'
                  }}
                  variant={'body2'}>
                  {subtitle}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Paper>
  );
};

KpiBox.propTypes = {
  loading: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subtitle: PropTypes.string,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default KpiBox;
